import React, { useEffect, useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  SafeAreaView,
  Image,
  ImageBackground,
  TextInput,
} from "react-native";
import Dawer from "../../component/drawer";
import Admin from "../../component/admin";
import Tabledis from "./tabledis";
import { Octicons } from "@expo/vector-icons";
import { apiservice } from "../../service/service";
import { useIsFocused } from "@react-navigation/native";
import { useRecoilState } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
import RNPickerSelect, { defaultStyles } from "react-native-picker-select";
const { width, height } = Dimensions.get("window");
export default function discount({ navigation }) {
  const focus = useIsFocused();
  const [token, setToken] = useRecoilState(tokenState);
  const [data, setdata] = useState([]);
  const [sType, setType] = useState(null);
  console.log('====================================');
  console.log(sType);
  console.log('====================================');

  async function getalldiscount_list() {
    const response = await apiservice({
      path: "/freepoint/getalldiscount_list",
      method: "get",
      token: token?.accessToken,
    });
    if (response.status == 200) {
      setdata(response.data);
    }
  }
  const placeholder1 = {
    label: "หมวดหมู่",
    value: null,
    color: "#777777",
  };
  const [items1, setItems1] = useState([
    { label: "อาหาร", value: "Food" },
    { label: "คอมพิวเตอร์", value: "Computer" },
    { label: "ห้องพัก", value: "Room" },
    { label: "เครื่องใช้ไฟฟ้า", value: "Electric" },
  ]);
  useEffect(() => {
    getalldiscount_list();
  }, [focus]);
  return (
    <View style={styles.container}>
      <Dawer navigation={navigation} />
      <View style={styles.back}>
        <Admin />
        <View style={styles.viewfree}>
          <Text style={styles.textfree}>DISCOUNT</Text>
          <TouchableOpacity
            onPress={() => navigation.navigate("CreateDiscount")}
            style={styles.touchadd}
          >
            <Text style={styles.textadd}>ADD</Text>
          </TouchableOpacity>
        </View>
        <View style={styles.viewfree}>
          <View style={{ flexDirection: "row" }}>
            <RNPickerSelect
              placeholder={placeholder1}
              style={{
                inputWeb: {
                  width: width * 0.15,
                  height: 30,
                  borderWidth: 1,
                  borderColor: "#ccc",
                  paddingLeft: 10,
                  borderRadius: 5,
                  color: "#777777",
                  fontFamily: "Prompt-Regular",
                  alignSelf: "center",
                },
              }}
              onValueChange={(value) => {
                setType(value == "หมวดหมู่" ? null : value);
              }}
              items={items1}
            />
            <Octicons
              name="triangle-down"
              size={20}
              color="#FCC81D"
              style={{ alignSelf: "center", marginLeft: -20 }}
            />
          </View>

          <Text style={styles.textsum}>
            มีจำนวนทั้งหมด{" "}
            {
              data?.filter((e) => (sType ? e?.category_name == sType : true))
                .length
            }{" "}
            รายการ
          </Text>
        </View>
        <Tabledis
          onSuccess={getalldiscount_list}
          data={data?.filter((e) => (sType ? e?.category_name == sType : true))}
          navigation={navigation}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F3F3F3",
    flexDirection: "row",
  },
  back: {
    width: "85%",
    height: height,
    paddingHorizontal: "1%",
  },
  viewfree: {
    justifyContent: "space-between",
    width: "100%",
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    backgroundColor: "#fff",
    alignSelf: "center",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 24,
    color: "#172B4D",
    alignSelf: "center",
  },
  textsum: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "flex-end",
    marginTop: 10,
  },
  touchlong: {
    width: width * 0.18,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    marginTop: 5,
  },
  textadd1: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
    marginTop: 5,
  },
});
